/**
 * Create tennis results in popup
 */

import {
  createElement,
  getItemLocalStorage,
  setItemLocalStorage,
  select,
  selectAll,
  sortObjectByKeys,
} from "@utils/function";

export default function ResultsTennis() {
  const resultsContentSlider = select(".results-content .slider-content");

  resultsContentSlider.textContent = "";

  const tennisResults = HQ.Properties.results;

  // check if tennisResults element is empty or undefined
  const head = Object.entries(tennisResults)
    .map(([key, value]) => {
      if (value.length <= 0) return;
      return key;
    })
    .filter((key) => key !== undefined);

  // --------------------------------------------
  // create select match
  resultsContentSlider.insertAdjacentElement(
    "beforeend",
    createSelectMatch(tennisResults, head)
  );

  // --------------------------------------------
  // create results for each match

  Object.entries(tennisResults).forEach(([key, value], index) => {
    if (value.length <= 0) return;

    if (head.includes(key)) {
      const body = createBodyResults(value, key, head, index);
      resultsContentSlider.insertAdjacentElement("beforeend", body);
    }
  });

  // --------------------------------------------
  // show selected results

  showSelectedResults();
}

/**
 * Show selected results
 */
function showSelectedResults() {
  const selectResults = select(".tennis-select-results");
  selectResults.addEventListener("change", (e) => {
    const value = e.target.value;

    setItemLocalStorage("HQtennisResults", value);

    const results = select(`#${value}`);
    const allResults = selectAll(".tennis-row");

    allResults.forEach((result) => {
      result.classList.add("d-none");
    });

    results.classList.remove("d-none");
  });
}

/**
 * Create select match
 *
 * @param {obj} obj
 * @param {string} head
 */
function createSelectMatch(obj, head) {
  const selectMatch = createElement("div");
  selectMatch.classList.add("tennis-select-match");

  // get selected option from local storage
  const HQtennisResults = getItemLocalStorage("HQtennisResults");

  const createSelect = createElement("select");
  createSelect.classList.add("tennis-select-results");

  Object.entries(obj).forEach(([key, value], index) => {
    if (head.includes(key)) {
      const option = createElement("option");
      option.value = key.toLowerCase();
      option.textContent = createHeaderResults(key);

      // set selected option
      option.selected = HQtennisResults === key.toLowerCase() ? true : false;
      createSelect.insertAdjacentElement("beforeend", option);
    }
  });

  selectMatch.insertAdjacentElement("beforeend", createSelect);

  return selectMatch;
}

/**
 * Create body for results
 *
 * @param {array} array
 * @param {string} key
 * @param {number} index
 * @returns  HTMLElement
 */

function createBodyResults(array, key, head, index) {
  const headRow = createElement("div");
  headRow.classList.add("tennis-row");
  headRow.id = key.toLowerCase();

  // get selected option from local storage
  const HQtennisResults = getItemLocalStorage("HQtennisResults");

  if (HQtennisResults === key.toLowerCase()) {
    headRow.classList.remove("d-none");
  } else {
    headRow.classList.add("d-none");
    if (!HQtennisResults) {
      const firsrtElement = head[0].toLowerCase();
      const findElementById = select(`#${firsrtElement}`);
      findElementById?.classList.remove("d-none");
    }
  }

  array.map((item, index) => {
    if (array[index - 1]?.RoundLongName !== item.RoundLongName) {
      headRow.innerHTML += `<div class="tennis-second-row px-2 py-1">${item.RoundLongName}</div>`;
    }

    headRow.innerHTML += getPlayersName(item);
  });

  return headRow;
}

/**
 * Create header for results
 *
 * @param {string} element
 * @returns HTMLElement
 */
function createHeaderResults(element) {
  let eventtypeName;

  switch (element) {
    // -------------------------
    // ATP
    case "MS":
      eventtypeName = HQ.Properties.i18n.tennisEventTypeName.MS;
      break;
    case "MD":
      eventtypeName = HQ.Properties.i18n.tennisEventTypeName.MD;
      break;
    case "QS":
      eventtypeName = HQ.Properties.i18n.tennisEventTypeName.QS;
      break;
    case "QD":
      eventtypeName = HQ.Properties.i18n.tennisEventTypeName.QD;
      break;
    // -------------------------
    // WTA
    case "LS":
      eventtypeName = HQ.Properties.i18n.tennisEventTypeName.LS;
      break;
    case "LD":
      eventtypeName = HQ.Properties.i18n.tennisEventTypeName.LD;
      break;
    case "RS":
      eventtypeName = HQ.Properties.i18n.tennisEventTypeName.RS;
      break;
    case "RD":
      eventtypeName = HQ.Properties.i18n.tennisEventTypeName.RD;
      break;

    default:
      break;
  }

  return eventtypeName;
}
/**
 * Get players name
 *
 * @param {object} players
 * @returns string
 */
function getPlayersName(players) {
  const orderedObject = sortObjectByKeys(players);

  const {
    PlayerFirstName,
    PlayerLastName,
    PlayerNatlId,
    PlayerId,
    PartnerFirstName,
    PartnerNatlId,
    PartnerLastName,
    PartnerId,
    OpponentFirstName,
    OpponentLastName,
    OpponentNatlId,
    OpponentId,
    OpponentPartnerFirstName,
    OpponentPartnerLastName,
    OpponentPartnerNatlId,
    OpponentPartnerId,
  } = orderedObject;

  // -------------------------
  let playerRow = "";

  if (PlayerFirstName) {
    const config = {
      firstName: PlayerFirstName,
      lastName: PlayerLastName,
      natlId: PlayerNatlId,
    };
    playerRow = rowPlayer(config, "left");
  }

  // -------------------------
  let partnerRow = "";

  if (PartnerFirstName) {
    const config = {
      firstName: PartnerFirstName,
      lastName: PartnerLastName,
      natlId: PartnerNatlId,
    };
    partnerRow = rowPlayer(config, "left");
  }

  // -------------------------
  let opponentRow = "";

  if (OpponentFirstName) {
    const config = {
      firstName: OpponentFirstName,
      lastName: OpponentLastName,
      natlId: OpponentNatlId,
    };
    opponentRow = rowPlayer(config, "right");
  }

  // -------------------------
  let opponentPartnerRow = "";

  if (OpponentPartnerFirstName) {
    const config = {
      firstName: OpponentPartnerFirstName,
      lastName: OpponentPartnerLastName,
      natlId: OpponentPartnerNatlId,
    };
    opponentPartnerRow = rowPlayer(config, "right");
  }

  let playersID = "";
  playersID += PlayerId ? PlayerId : "";
  playersID += PartnerId ? `,${PartnerId}` : "";
  playersID += OpponentId ? `,${OpponentId}` : "";
  playersID += OpponentPartnerId ? `,${OpponentPartnerId}` : "";

  const hasFavoritePlayer = checkFavoritePlayer(playersID)
    ? "favorite-player"
    : "";

  const playerRowDiv = `
    <div class="container flex-column border-bottom">
      <div class="row align-items-center ${hasFavoritePlayer}">
        <div class="col-4 p-2">${playerRow}${partnerRow ?? ""}</div>
        <div class="col-1 schedule-de text-rotation">-</div>
        <div class="col-4 p-2">${opponentRow}${opponentPartnerRow ?? ""}</div>
        <div class="col-3 p-0">
          <div class="results-points">
            ${getScoreColumn(orderedObject)}
          </div>
        </div>
      </div>
    </div>
  `;

  return playerRowDiv;
}

/**
 * Create player row
 *
 * @param {object} obj
 * @param {string} type
 * @returns string
 */
function rowPlayer(obj, type) {
  let { firstName, lastName, natlId } = obj;

  firstName = firstName ? firstName.slice(0, 1) + ". " : "";

  return `
    <div class="player-row tennis-flag d-flex gap-2 align-items-center">
      <div title="${natlId}" class="col-2 flag-icon flag-icon-${natlId?.toLowerCase()}"></div>
      <div class="col-10">${firstName}${lastName}</div>
    </div>
  `;
}

/**
 * Get score for results
 *
 * @param {object} obj
 * @returns HTMLElement
 */
function getScoreColumn(obj) {
  // const getValue = (part, o) =>
  //   Object.entries(o).find(([k, v]) => k.startsWith(part));

  const {
    Set1Player,
    Set1Opponent,
    Set1Tie,
    Set2Player,
    Set2Opponent,
    Set2Tie,
    Set3Player,
    Set3Opponent,
    Set3Tie,
    Set4Player,
    Set4Opponent,
    Set4Tie,
    Set5Player,
    Set5Opponent,
    Set5Tie,
    Reason,
  } = obj;

  let templateResults = `
    ${Set1Player ?? ""}${Set1Opponent ?? ""}
    ${Set1Tie ? `<sup>${Set1Tie}</sup>` : ""}
    ${Set2Player ?? ""}${Set2Opponent ?? ""}
    ${Set2Tie ? `<sup>${Set2Tie}</sup>` : ""}
    ${Set3Player ?? ""}${Set3Opponent ?? ""}
    ${Set3Tie ? `<sup>${Set3Tie}</sup>` : ""}
    ${Set4Player ?? ""}${Set4Opponent ?? ""}
    ${Set4Tie ? `<sup>${Set4Tie}</sup>` : ""}
    ${Set5Player ?? ""}${Set5Opponent ?? ""}
    ${Set5Tie ? `<sup>${Set5Tie}</sup>` : ""}
    ${Reason ?? ""}`;

  // remove new line and muldiple spaces and space before sup
  templateResults = templateResults
    .replace(/\s+/g, " ")
    .trim()
    .replace(/ <sup/g, "<sup");

  return templateResults;
}

/**
 * Check if favorite player in local storage
 */
function checkFavoritePlayer(playersID) {
  const arrayPlayersID = playersID.split(",");

  const getFavoritePlayer = getItemLocalStorage("HQfavoritePlayers");

  // elements from arrayPlayersID find in getFavoritePlayer
  const favoritePlayer = arrayPlayersID.filter((item) =>
    getFavoritePlayer.includes(item)
  );

  return favoritePlayer.length > 0 ? true : false;
}
